import React from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";

const works = {
  knell: {
    title: "Knell",
    year: "2026",
  },
  ocean: {
    title: "Ocean",
    year: "2026",
  },
  "in-quarters": {
    title: "In Quarters",
    year: "2026",
  },
  "tie-and-untie": {
    title: "Tie & Untie",
    year: "2025",
  },
  surveillance: {
    title: "Surveillance",
    year: "2025",
    instrumentation: "Dance composition",
    audio: [{ src: "/media/Final_DanceComposition_Video_MuratGulcelik.mp4", type: "video/mp4" }],
  },
  wait: {
    title: "Wait",
    year: "2025",
    instrumentation: "Modular synths",
    audio: [{ src: "/audio/wait.m4a", type: "audio/mp4" }],
  },
  stagnate: {
    title: "Stagnate",
    year: "2025",
    instrumentation: "Electronics",
    audio: [{ src: "/audio/stagnate.m4a", type: "audio/mp4" }],
  },
  poyraz: {
    title: "Poyraz",
    year: "2025",
  },
  yakamoz: {
    title: "Yakamoz",
    year: "2024",
    instrumentation: "2 pianos, 2 percussionists",
    score: "/Gulcelik_Murat_Yakamoz_FinalScore_2024_11_20.pdf",
    audio: [{ src: "/audio/yakamoz.m4a", type: "audio/mp4" }],
  },
  clarity: {
    title: "Clarity",
    year: "2024",
    instrumentation: "Soft synths, drones",
    audio: [{ src: "/audio/clarity.m4a", type: "audio/mp4" }],
  },
  surrounded: {
    title: "Surrounded",
    year: "2024",
    instrumentation: "Electronics",
    audio: [{ src: "/audio/surrounded.mp3", type: "audio/mpeg" }],
  },
  sparrow: {
    title: "Sparrow",
    year: "2023",
  },
  "antony-and-cleopatra": {
    title: "Antony & Cleopatra",
    year: "2022",
  },
};

function SectionLabel({ children }) {
  return (
    <h3 className="font-sans text-[11px] font-semibold tracking-[0.06em] uppercase text-[var(--faint)] mb-3">
      {children}
    </h3>
  );
}

export default function WorkDetail() {
  const { slug } = useParams();
  const work = works[slug];

  if (!work) {
    return (
      <div className="max-w-[800px] mx-auto px-6 sm:px-8 py-20 sm:py-28">
        <p className="font-sans text-[14px] text-[var(--muted)]">Work not found.</p>
        <Link
          to="/about"
          className="inline-block mt-4 font-sans text-[12px] text-[var(--muted)] hover:text-[var(--text)] transition-colors"
        >
          ← Back
        </Link>
      </div>
    );
  }

  return (
    <motion.div
      className="max-w-[800px] mx-auto px-6 sm:px-8 py-20 sm:py-28"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Link
        to="/about"
        className="inline-block mb-12 font-sans text-[12px] text-[var(--muted)] hover:text-[var(--text)] transition-colors"
      >
        ← Back
      </Link>

      <h1 className="font-serif italic text-[32px] sm:text-[40px] text-[var(--text)] leading-[1] mb-3">
        {work.title}
      </h1>

      <div className="flex items-baseline gap-3 mb-16">
        <span className="font-mono text-[12px] text-[var(--muted)]">
          {work.year}
        </span>
        {work.instrumentation && (
          <>
            <span className="text-[var(--faint)]">·</span>
            <span className="font-sans text-[13px] text-[var(--muted)]">
              {work.instrumentation}
            </span>
          </>
        )}
      </div>

      <div className="space-y-12">
        {work.score && (
          <div>
            <SectionLabel>Score</SectionLabel>
            <a
              href={work.score}
              target="_blank"
              rel="noopener noreferrer"
              className="font-sans text-[13px] text-[var(--body)] hover:text-[var(--text)] transition-colors underline underline-offset-[3px] decoration-[var(--rule)]"
            >
              View Score ↗
            </a>
          </div>
        )}

        {work.audio && (
          <div>
            <SectionLabel>Audio</SectionLabel>
            <audio controls preload="metadata" className="w-full max-w-[400px]">
              {work.audio.map((s) => (
                <source key={s.src} src={s.src} type={s.type} />
              ))}
            </audio>
          </div>
        )}

        <div>
          <SectionLabel>Description</SectionLabel>
          <p className="font-sans text-[14px] leading-[1.8] text-[var(--muted)] italic">
            Coming soon.
          </p>
        </div>
      </div>
    </motion.div>
  );
}
